export const APP_ERROR_MESSAGES = {
    HOSPITAL_CREATION_FAILED: 'Hospital creation failed',
    REQUEST_TIMEOUT: 'The request timed out. Please try again.',
    NETWORK_ERROR: 'Network error. Please check your internet connection and try again.',
    FEEDBACK_SAVE_FAILED: 'Failed to save feedback.',
    ACCESS_TOKEN_MISSING: 'Access token missing from refresh response',
    NO_REFRESH_TOKEN_AVAILABLE: 'No refresh token available'
};
